/*
 * MN WhatsApp sun — desktop CSS hover; mobile FAB + note that hides while scrolling.
 */
class MnWhatsappSun extends HTMLElement {
  connectedCallback() {
    this.cleanup();
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.linkDesktop = this.querySelector('.mn-whatsapp-sun__link--desktop');
    this.linkMobile = this.querySelector('.mn-whatsapp-sun__link--mobile');
    this.mobileWrap = this.querySelector('.mn-whatsapp-sun__mobile');
    this.note = this.querySelector('.mn-whatsapp-sun__note');
    this.noteLink = this.querySelector('.mn-whatsapp-sun__note-link');
    this.autoShowTimer = null;
    this.scrollIdleTimer = null;
    this.isScrolling = false;
    this.userDismissed = false;
    this.noteOpenedOnce = false;

    this.onScrollActivity = this.onScrollActivity.bind(this);
    this.onMobileChange = this.syncMobileNote.bind(this);
    this.onMobileLinkClick = this.onMobileLinkClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    if (!(this.mobileWrap instanceof HTMLElement) || !(this.note instanceof HTMLElement)) return;

    this.mobileMq = window.matchMedia('(max-width: 749px)');
    if (typeof this.mobileMq.addEventListener === 'function') {
      this.mobileMq.addEventListener('change', this.onMobileChange, { signal });
    } else {
      this.mobileMq.addListener(this.onMobileChange);
    }

    this.linkMobile?.addEventListener('click', this.onMobileLinkClick, { signal });
    document.addEventListener('keydown', this.onKeydown, { signal });

    // Hide note while the page is swiped/scrolled; reveal again when idle.
    window.addEventListener('scroll', this.onScrollActivity, { passive: true, capture: true, signal });
    window.addEventListener('touchmove', this.onScrollActivity, { passive: true, capture: true, signal });
    document.addEventListener('scroll', this.onScrollActivity, { passive: true, capture: true, signal });

    this.syncMobileNote();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  cleanup() {
    this.clearTimers();
    if (this.mobileMq && this.onMobileChange && typeof this.mobileMq.removeListener === 'function') {
      try {
        this.mobileMq.removeListener(this.onMobileChange);
      } catch (e) {
        /* ignore */
      }
    }
    this.abortController?.abort();
    this.abortController = null;
    this.closeNote(false);
    this.isScrolling = false;
  }

  clearTimers() {
    if (this.autoShowTimer !== null) {
      window.clearTimeout(this.autoShowTimer);
      this.autoShowTimer = null;
    }
    if (this.scrollIdleTimer !== null) {
      window.clearTimeout(this.scrollIdleTimer);
      this.scrollIdleTimer = null;
    }
  }

  get isMobile() {
    return this.mobileMq?.matches === true;
  }

  syncMobileNote() {
    this.clearTimers();
    this.isScrolling = false;
    this.userDismissed = false;

    if (!this.isMobile) {
      this.closeNote(false);
      return;
    }

    this.scheduleShowNote(1200);
  }

  scheduleShowNote(delay = 280) {
    if (this.autoShowTimer !== null) {
      window.clearTimeout(this.autoShowTimer);
      this.autoShowTimer = null;
    }
    if (!this.isMobile || this.userDismissed) return;

    this.autoShowTimer = window.setTimeout(() => {
      this.autoShowTimer = null;
      if (!this.isConnected || !this.isMobile || this.isScrolling || this.userDismissed) return;
      this.openNote();
    }, delay);
  }

  onScrollActivity() {
    if (!this.isMobile) return;

    if (!this.isScrolling) {
      this.isScrolling = true;
      this.closeNote(true);
    }

    if (this.scrollIdleTimer !== null) {
      window.clearTimeout(this.scrollIdleTimer);
    }
    if (this.autoShowTimer !== null) {
      window.clearTimeout(this.autoShowTimer);
      this.autoShowTimer = null;
    }

    this.scrollIdleTimer = window.setTimeout(() => {
      this.scrollIdleTimer = null;
      this.isScrolling = false;
      if (!this.isConnected || !this.isMobile || this.userDismissed) return;
      this.scheduleShowNote(120);
    }, 320);
  }

  openNote() {
    if (!(this.note instanceof HTMLElement) || !(this.mobileWrap instanceof HTMLElement)) return;
    if (this.isScrolling) return;
    this.noteOpenedOnce = true;
    this.mobileWrap.classList.add('is-note-open');
    this.note.setAttribute('aria-hidden', 'false');
  }

  closeNote(animate = true) {
    if (!(this.note instanceof HTMLElement) || !(this.mobileWrap instanceof HTMLElement)) return;
    this.mobileWrap.classList.remove('is-note-open');
    this.note.setAttribute('aria-hidden', 'true');
    if (!animate) {
      /* instant hide for teardown / desktop */
    }
  }

  onMobileLinkClick(event) {
    if (!this.isMobile) return;

    // First interaction reveals the note; later taps open WhatsApp.
    if (!this.noteOpenedOnce) {
      event.preventDefault();
      this.userDismissed = false;
      this.openNote();
    }
  }

  onKeydown(event) {
    if (event.key !== 'Escape') return;
    if (!this.mobileWrap?.classList.contains('is-note-open')) return;
    this.userDismissed = true;
    this.closeNote();
  }
}

if (!customElements.get('mn-whatsapp-sun')) {
  customElements.define('mn-whatsapp-sun', MnWhatsappSun);
}

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target;
  if (!(root instanceof Element)) return;
  root.querySelectorAll('mn-whatsapp-sun').forEach((el) => {
    if (el instanceof MnWhatsappSun && el.isConnected) {
      el.connectedCallback();
    }
  });
});
